import styled from '@emotion/styled';
// --- external imports -----

const PopupModalContainer = styled.div`
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.72);
	z-index: 400;
`;

export default PopupModalContainer;
